module.exports = __webpack_public_path__ + "static/img/3.cf3b4a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/internetimg/3.png
// module id = cNs2
// module chunks = 9